/**
 * Wraps an action function that returns a promise, allowing for consistent handling
 * of resolving and rejecting the promise.
 *
 * @template T - The type of the payload passed to the action function.
 * @template U - The type of the value resolved by the action function's promise.
 *
 * @param action - A function that takes a payload of type `T` and returns a promise of type `U`.
 * @param payload - The payload of type `T` to be passed to the action function.
 *
 * @returns A promise of type `U` that resolves with the value returned by the action or
 *          rejects with an error.
 */
export function setPromiseCall<T, U>(
  action: (payload: T) => Promise<U>,
  payload: T,
): Promise<U> {
  return new Promise((resolve, reject) => {
    action(payload)
      .then(data => resolve(data))
      .catch(error => reject(error));
  });
}
